import { IBaseModel } from "../BaseModel";

export interface ICustomerSetting extends IBaseModel {
  key: string;
  value: string;
  isVisibleToCustomer: boolean;
  settingType: SettingType;
  required: boolean;
  inputType: InputType;
}

export enum SettingType {
  General,
  Shipping
}

export enum InputType {
  Text,
  Toggle,
  Number
}
